import React from "react";
import { Truck, Bike, IndianRupee } from "lucide-react";

/**
 * Earnings Breakdown Panel
 * 
 * Shows breakdown by earnings source.
 */
export function EarningsBreakdown({ summary, platformCommission }) {
  return (
    <div className="border border-border p-6 space-y-4">
      <h3 className="font-bold text-lg">Earnings Breakdown</h3>
      <div className="space-y-3">
        <BreakdownRow
          icon={Truck}
          label="Cargo & Jet Bookings"
          amount={summary.cargo_jet_earnings || 0}
        />
        <BreakdownRow
          icon={Bike}
          label="Local Deliveries"
          amount={summary.delivery_earnings || 0}
        />
        <BreakdownRow
          icon={IndianRupee}
          label="Cancellation Compensations"
          amount={summary.compensation_earnings || 0}
          noBorder
        />
      </div>
      <div className="pt-4 border-t border-border">
        <p className="text-sm text-muted-foreground">
          Platform commission: {platformCommission || "2%"}
        </p>
      </div>
    </div>
  );
}

function BreakdownRow({ icon: Icon, label, amount, noBorder }) {
  return (
    <div className={`flex justify-between items-center py-2 ${!noBorder ? 'border-b border-border' : ''}`}>
      <div className="flex items-center gap-2">
        <Icon className="w-4 h-4 text-muted-foreground" />
        <span>{label}</span>
      </div>
      <span className="font-bold">₹{amount?.toLocaleString()}</span>
    </div>
  );
}

/**
 * Monthly Earnings Panel
 * 
 * Shows earnings by month.
 */
export function MonthlyEarnings({ monthlyData }) {
  return (
    <div className="border border-border p-6 space-y-4">
      <h3 className="font-bold text-lg">Monthly Earnings</h3>
      {Object.keys(monthlyData || {}).length > 0 ? (
        <div className="space-y-2">
          {Object.entries(monthlyData).map(([month, amount]) => (
            <div key={month} className="flex justify-between items-center py-2 border-b border-border last:border-0">
              <span className="text-muted-foreground">{month}</span>
              <span className="font-bold">₹{amount?.toLocaleString()}</span>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-muted-foreground text-center py-8">No earnings data yet</p>
      )}
    </div>
  );
}
